import { useMutation } from '@tanstack/react-query';
import { shippingService } from '@/services/shipping.service';
import { toast } from 'sonner';

export const useValidatePincode = () => {
  return useMutation({
    mutationFn: (pincode: string) => shippingService.validatePincode(pincode),
    onError: (error: any) => {
      toast.error(error.message || 'Failed to validate pincode');
    },
  });
};

export const useCalculateShipping = () => {
  return useMutation({
    mutationFn: (params: {
      destinationPincode: string;
      itemCount?: number;
      orderValue?: number;
      cod?: boolean;
    }) => shippingService.calculateShippingCost(params),
    onError: (error: any) => {
      toast.error(error.message || 'Failed to calculate shipping cost');
    },
  });
};

export const useTrackShipment = () => {
  return useMutation({
    mutationFn: (params: { orderId: string; shipmentId: string }) => shippingService.trackShipment(params.orderId, params.shipmentId),
    onError: (error: any) => {
      toast.error(error.message || 'Failed to track shipment');
    },
  });
};

export const useTrackByNumber = () => {
  return useMutation({
    mutationFn: (trackingNumber: string) => shippingService.trackByNumber(trackingNumber),
    onError: (error: any) => {
      toast.error(error.message || 'Invalid tracking number');
    },
  });
};